import {
  // IconMapPin,
  IconFilter,
  // IconTool,
  IconAbc,
  IconMessageChatbot,
} from '@tabler/icons-react';

import EnumNodeType from './types';

const NodesOptions = [
  // {
  //   enumNodeType: EnumNodeType.INITIAL,
  //   IconComponent: IconMapPin,
  //   title: 'initial_node',
  //   iconColor: '#13deb9',
  // },
  {
    enumNodeType: EnumNodeType.KEYWORDS,
    IconComponent: IconAbc,
    title: 'keywords_node',
    iconColor: '#1682d4',
  },
  {
    enumNodeType: EnumNodeType.MESSAGE,
    IconComponent: IconMessageChatbot,
    title: 'message_node',
    iconColor: '#23afdb',
  },
  {
    enumNodeType: EnumNodeType.FILTER,
    IconComponent: IconFilter,
    title: 'filter_node',
    iconColor: '#ffad1f',
  }
  // {
  //   enumNodeType: EnumNodeType.TOOL,
  //   IconComponent: IconTool,
  //   title: 'tool_node',
  //   iconColor: '#FA896B',
  // },
];

export const ToolOptions = [
  {
    title: 'tool_travel',
    value: 'getTrips',
  },
  {
    title: 'tool_travel_details',
    value: 'getTripDetails',
  },
  {
    title: 'tool_machinery_tools',
    value: 'getMachineryAndTools',
  },
  {
    title: 'tool_leads',
    value: 'saveLead',
  },
  {
    title: 'tool_real_state',
    value: 'getProperties',
  },
  {
    title: 'tool_location',
    value: 'getLocationLatLong',
  },
  {
    title: 'tool_notify_human',
    value: 'notifyToHuman',
  },
  {
    title: 'tool_disable_ai',
    value: 'disableAI',
  },
];

export const connectionLineConfig = {
  type: 'smoothstep',
  style: {
    stroke: '#5D87FF',
    strokeWidth: 3,
  },
};

export const deleteActions = new Map([
  ['initial-message', 'removeInitialRelation'],
  ['initial-tool', 'removeInitialRelation'],
  ['message-keywords', 'removeKeywordsRelation'],
  ['tool-keywords', 'removeKeywordsRelation'],
  ['message-filter', 'removeFilterRelation'],
  ['filter-message', 'removeMessageFilterRelation'],
  ['filter-tool', 'removeToolFilterRelation'],
  ['tool-filter', 'removeFilterRelation'],
]);

export const connectActions = new Map([
  ['initial-message', 'updateInitialNode'],
  ['initial-tool', 'updateInitialNode'],
  ['message-keywords', 'updateBaseKeywords'],
  ['tool-keywords', 'updateBaseKeywords'],
  ['message-filter', 'updateBaseFilters'],
  ['filter-message', 'updateFilterMessage'],
  ['filter-tool', 'updateFilterTool'],
  ['tool-filter', 'updateBaseFilters'],
  ['tool-loop', 'updateLoopBranch'],
]);

export default NodesOptions;
